import React from "react";
import "../../styles/Tabella.css"


interface TabellaOrariProps {

}

function TabellaOrariAcq() {
    return(
        <div className="d-flex flex-column m-auto" style={{maxWidth: "50em"}}>
            <div className="table-container">
            <table className="table text-center m-auto" style={{width: "90%", maxWidth: "40em"}}>
                <thead>
                <tr>
                    <th className="" scope="col">Sabato</th>
                    <th className="" scope="col">Domenica</th>
                </tr>
                </thead>
                <tbody>
                <tr><td className="data-cell">9:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 9:40</td>
                    <td className="data-cell">
                        9:10 <br className="d-sm-none"/> - <br className="d-sm-none"/> 9:40
                        <br/>
                        <span style={{fontSize: "14px"}}>(neonatale 6-12 mesi)</span>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell"></td>
                    <td className="data-cell">9:35 <br className="d-sm-none"/> - <br className="d-sm-none"/> 10:15</td>
                </tr>
                <tr>
                    <td className="data-cell">9:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 10:25</td>
                    <td className="data-cell">9:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 10:15 <br/><span style={{fontSize: "14px"}}>(neonatale 6-12 mesi)</span></td>
                </tr>
                <tr>
                    <td className="data-cell">10:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 11:10</td>
                    <td className="data-cell">10:20 <br className="d-sm-none"/> - <br className="d-sm-none"/> 11:00</td>
                </tr>
                <tr>
                    <td> </td>
                    <td className="data-cell">11:05 <br className="d-sm-none"/> - <br className="d-sm-none"/> 11:45</td>
                </tr>
                </tbody>
            </table>
        </div>
        </div>
    )
}
export default TabellaOrariAcq